import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Bell, Heart, MessageCircle, Star, TrendingUp, Wallet } from "lucide-react";

const POOL = [
  { icon: Bell, title: "Nowa subskrypcja", sub: "przed chwilą" },
  { icon: Wallet, title: "Napiwek +120 zł", sub: "od fana" },
  { icon: MessageCircle, title: "Nowa wiadomość", sub: "czeka na odpowiedź" },
  { icon: Heart, title: "Nowy fan", sub: "właśnie dołączył" },
  { icon: TrendingUp, title: "Sprzedaż +240 zł", sub: "pakiet premium" },
  { icon: Star, title: "Nowy VIP", sub: "subskrypcja roczna" },
];

export const HeroNotifications = () => {
  const [items, setItems] = useState([]);
  const idx = useRef(0);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const spawn = () => {
      const item = POOL[idx.current % POOL.length];
      idx.current += 1;
      const key = Date.now() + Math.random();
      const jitter = (Math.random() * 40 - 20);
      setItems((prev) => [...prev, { ...item, key, jitter }]);
      setTimeout(() => {
        setItems((prev) => prev.filter((x) => x.key !== key));
      }, 3200);
    };

    const startTimer = setTimeout(spawn, 1800);
    const interval = setInterval(spawn, 1700);
    return () => {
      clearTimeout(startTimer);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="hidden lg:block absolute z-30 pointer-events-none" style={{ top: "44%", right: "16%" }}>
      <AnimatePresence>
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <motion.div
              key={it.key}
              initial={{ opacity: 0, y: 10, scale: 0.75, x: it.jitter }}
              animate={{ opacity: [0, 1, 1, 0], y: -160, scale: 1, x: it.jitter + 40 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 3.2, ease: [0.16, 1, 0.3, 1], times: [0, 0.12, 0.7, 1] }}
              className="absolute glass rounded-xl pl-2.5 pr-4 py-2 flex items-center gap-2.5 shadow-[0_10px_34px_rgba(0,0,0,0.5)] whitespace-nowrap"
            >
              <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-coral/20 text-coral">
                <Icon size={14} strokeWidth={2.3} />
              </span>
              <span className="leading-tight">
                <span className="block text-white font-semibold text-[13px] leading-none">{it.title}</span>
                <span className="block text-[10px] text-white/55 mt-0.5">{it.sub}</span>
              </span>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
